module.exports = __webpack_public_path__ + "static/media/innerbanner.14b45de7.jpg";